export default "__VITE_ASSET__CptP3t$u__"